export default function leadsRegistration(){

    const LEAD_REGISTRATION_API = "https://lead-dot-staging-dot-aw-web.appspot.com/";
    let leadInfo = {};
    const registerBtn = document.querySelector('#register');

    function onFocus(event) {
        if (event.target.classList.contains('is-invalid')) {
          event.target.classList.remove('is-invalid');
        }
      }

      function onBlur(event, info) {
        leadInfo[info.emittedBy] = info;
      }

      leadInfo = window.InputValidator && window.InputValidator.fields.initialize({
        fields: {
          phone: { selector: '#phone', type: 'phone', withDialCodePicker: true, errorClassName: 'is-invalid'},
          email: { selector: '#mail', type: 'email', errorClassName: 'is-invalid' },
          company: { selector: '#company', type: 'text', errorClassName: 'is-invalid' },
          name: { selector: '#name', type: 'text', errorClassName: 'is-invalid' },
        },
        eventListeners: {
          blur: onBlur,
          focus: onFocus,
        },
      });

      function isLeadInfoValid() {
        if (leadInfo && Object.keys(leadInfo).length) {
          if ((Object.values(leadInfo).filter(value => value.valid).length
          === Object.keys(leadInfo).length)) {
            return true;
          }
          return false;
        }
        return false;
      }

      async function processLeadRegistration(payload) {
        try {
          let response = await window.fetch(LEAD_REGISTRATION_API+ `/registration`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: payload
          });
          response = await response.json();
          if(response.ok){
            window.location.href = '/thank-you'
          }
        } catch (e) {
            console.error(e) // eslint-disable-line
        }
      }

      registerBtn && registerBtn.addEventListener('click', () => {
        event.preventDefault();
        if (isLeadInfoValid()) {
          registerBtn.setAttribute('style', 'pointer-events: none;cursor: default;');
          // document.getElementById('registration').classList.add('loading');
          const payload = Object.values(leadInfo).reduce((prevValue, currentValue) => {
            const prevValueRef = prevValue;
            const { value, emittedBy } = currentValue;
            if (emittedBy === 'phone') {
               const { dialCode, nationalNumber } = currentValue;
               prevValueRef.countryCode = dialCode;
               prevValueRef.phone = nationalNumber;
            } else {
              prevValueRef[emittedBy] = value;
            }
            return prevValueRef;
          }, {});
          processLeadRegistration(JSON.stringify(payload));
          let registrationForm = document.getElementById('registrationCard');
          registrationForm && registrationForm.classList.add('is-action');

        } else if (leadInfo && Object.keys(leadInfo).length) {
          Object.values(leadInfo).forEach((value) => {
            if (!value.valid && value.selector) {
              document.querySelector(value.selector).classList.add('is-invalid');
            }
          });
        }
      });
}
// Intltel Input Accessibility

window.addEventListener('load', () => {
  const flagContainer = document.querySelector('.iti__flag-container');
  const selectedFlag = document.querySelector('.iti__selected-flag');
  if (flagContainer) {
    flagContainer.setAttribute('aria-label', 'Country code');
  }

  if (selectedFlag) {
    selectedFlag.setAttribute('role', 'button');
    selectedFlag.setAttribute('aria-haspopup', 'true');
  }
});



// WEBPACK FOOTER //
// ./src/js/leads.js